module.exports = __webpack_public_path__ + "static/media/stories-bottom-icons.007e6b7a.svg";